











































import { Component, Vue, Prop } from 'nuxt-property-decorator';

@Component
export default class ShowHeader extends Vue {
  @Prop({ type: String, required: true })
  title!: string

  @Prop(String)
  subtitle!: string

  @Prop()
  image;

  @Prop(String)
  videoLoop!: string

  @Prop(String)
  videoTitle!: string

  @Prop(String)
  videoLength!: string

  @Prop(String)
  vimeoId!: string

  @Prop(String)
  youtubeId!: string

  modalOpen = false;

  get videoLabelId () {
    return `show-header-${this.vimeoId ? this.vimeoId : this.youtubeId}-label`;
  }

  toggleModalOpen () {
    this.modalOpen = !this.modalOpen;
  }
}
